// // /pages/FleetManagement/Drivers/DriversCAHistoryPage.tsx

// import React, { useState, useMemo, useRef, useEffect } from 'react';
// import { 
//     Box, Heading, Text, HStack, VStack, InputGroup, Input, 
//     InputRightElement, IconButton, Card, CardHeader, CardBody, 
//     Avatar, Icon, Divider, Tag
// } from '@chakra-ui/react';
// import { Search, Phone, Truck, ChevronLeft, Banknote } from 'lucide-react';
// import { useNavigate, useParams } from 'react-router-dom';
// import { AdminLayout } from '@/components/layout/AdminLayout';
// import { apiClient } from '@/lib/api/client';
// import { useToastNotification } from '@/lib/utils/useToastNotification';
// import { DataTable, type DataTableRef, type DataTableOptions } from '@/components/tables';
// import { useThemeColors } from '@/hooks/useThemeColors';

// interface DriverHeaderInfo {
//     full_name: string;
//     contact_number: string;
//     assigned_trucks: string[];
// }

// const DriversCAHistoryPage: React.FC = () => {
//     const { id } = useParams<{ id: string }>();
//     const navigate = useNavigate();
//     const colors = useThemeColors();
//     const tableRef = useRef<DataTableRef>(null);
//     const searchRef = useRef<HTMLInputElement>(null);
//     const { showError } = useToastNotification();

//     const [searchQuery, setSearchQuery] = useState('');
//     const [driverInfo, setDriverInfo] = useState<DriverHeaderInfo | null>(null);

//     useEffect(() => {
//         const fetchDriverDetails = async () => {
//             try {
//                 const res = await apiClient.get(`/drivers/${id}`);
//                 const driverData = res.data.data || res.data; 

//                 if (driverData) {
//                     setDriverInfo({
//                         full_name: `${driverData.first_name} ${driverData.last_name}`,
//                         contact_number: driverData.contact_number,
//                         assigned_trucks: driverData.assigned_truck_plate_numbers || []
//                     });
//                 }
//             } catch (err) {
//                 showError(err);
//             }
//         };
//         if (id) fetchDriverDetails();
//     }, [id, showError]);

//     const handleSearch = () => {
//         const query = searchRef.current?.value || '';
//         setSearchQuery(query); 
//         tableRef.current?.applyFilter('search', query); 
//     };

//     const tableOptions: DataTableOptions = useMemo(
//         () => ({
//             dataSource: `/drivers/get-cash-advance/${id}`, 
//             primaryKey: 'id',
//             dataKey: 'data', 
//             showSelection: false,
//             softDelete: false,
//             displayInModal: false,
//             noRecordText: 'No cash advance records found',
//             dataFields: {
//                 transaction_date: { 
//                     name: 'DATE ISSUED', 
//                     withSort: true,
//                     render: (val: string) => val ? new Date(val).toLocaleDateString('en-US', {
//                         month: 'long', day: 'numeric', year: 'numeric'
//                     }) : 'N/A'
//                 },
//                 amount: { 
//                     name: 'AMOUNT', 
//                     withSort: true,
//                     render: (val: number) => (
//                         <Text fontWeight="bold" color="green.600">
//                             {new Intl.NumberFormat('en-PH', { style: 'currency', currency: 'PHP' }).format(val)}
//                         </Text>
//                     )
//                 },
//                 shift: { 
//                     name: 'SHIFT', 
//                     withSort: true,
//                     render: (val: string) => (
//                         <Tag size="sm" colorScheme={val?.toLowerCase() === 'day' ? 'orange' : 'purple'} variant="subtle">
//                             {val}
//                         </Tag>
//                     )
//                 },
//             },
//         }),
//         [id]
//     );

//     if (!driverInfo) return null;

//     return (
//         <AdminLayout>
//             <Box p={4} h="100%" overflow="hidden" display="flex" flexDirection="column">
//                 <VStack spacing={4} align="stretch" flex="1" overflow="hidden" minH={0}>
                    
//                     <Card flexShrink={0} display="flex" flexDirection="column" flex="1" minH={0} overflow="hidden">
                        
//                         {/* Page Header */}
//                         <CardHeader py={3}>
//                             <HStack spacing={2} align="center" cursor="pointer" onClick={() => navigate('/fleet-management/drivers')} mb={1}>
//                                 <Icon as={ChevronLeft} boxSize={5} />
//                                 <Heading size="md" fontWeight="bold">Driver's Cash Advance History</Heading>
//                             </HStack>
//                             <Text fontSize="sm" color={colors.text} ml={7}>
//                                 View and manage driver's cash advancement records
//                             </Text>
//                         </CardHeader>

//                         {/* Driver Profile Summary */}
//                         <Box px={6} py={4} borderBottom="1px" borderColor="gray.100" bg="gray.50/30">
//                             <HStack spacing={10} align="center">
//                                 <HStack spacing={4} flex="1">
//                                     <Avatar size="md" name={driverInfo.full_name} bg="green.500" color="white" icon={<Banknote size={24} />} />
//                                     <VStack align="start" spacing={0}>
//                                         <Heading size="sm" color="gray.700">{driverInfo.full_name}</Heading>
//                                         <HStack color="gray.500" fontSize="xs">
//                                             <Icon as={Phone} size={12} />
//                                             <Text>{driverInfo.contact_number || 'N/A'}</Text>
//                                         </HStack>
//                                     </VStack>
//                                 </HStack>

//                                 <Divider orientation="vertical" height="30px" />

//                                 <Box minW="200px">
//                                     <Text fontSize="xs" fontWeight="bold" color="gray.400" mb={1}>ASSIGNED TRUCKS:</Text>
//                                     <HStack spacing={2}>
//                                         <Icon as={Truck} size={14} color="gray.400" />
//                                         {driverInfo.assigned_trucks.length ? (
//                                             driverInfo.assigned_trucks.map((plate: string) => (
//                                                 <Tag key={plate} colorScheme="blue" variant="subtle" size="sm">
//                                                     {plate}
//                                                 </Tag>
//                                             ))
//                                         ) : (
//                                             <Text fontSize="xs" color="gray.500">None Assigned</Text>
//                                         )}
//                                     </HStack>
//                                 </Box>
//                             </HStack>
//                         </Box>
                        
//                         {/* Table Controls */}
//                         <CardHeader py={0} px={6} mt={4}>
//                             <HStack justify="space-between" align="center" width="100%" pb={4}>
//                                 <Heading size="xs" color="gray.500" textTransform="uppercase" letterSpacing="wider">
//                                     Cash Advance Records
//                                 </Heading>
//                                 <Box flex="0 1 auto" minW="250px" maxW="400px">
//                                     <InputGroup size="sm">
//                                         <Input
//                                             ref={searchRef}
//                                             placeholder="Search by date, shift, or amount..."
//                                             onKeyDown={(e) => e.key === 'Enter' && handleSearch()}
//                                             defaultValue={searchQuery}
//                                         />
//                                         <InputRightElement width="2.5rem">
//                                             <IconButton
//                                                 aria-label="Search"
//                                                 icon={<Search size={16} />}
//                                                 size="sm"
//                                                 variant="ghost"
//                                                 onClick={handleSearch}
//                                             />
//                                         </InputRightElement>
//                                     </InputGroup>
//                                 </Box>
//                             </HStack>
//                         </CardHeader>
                        
//                         {/* DataTable Section */}
//                         <CardBody 
//                             p={0} 
//                             pt={1} 
//                             pb={4} 
//                             mx={6} 
//                             flex="1" 
//                             overflow="hidden" 
//                             display="flex" 
//                             flexDirection="column"
//                             sx={{ 
//                                 'th:first-of-type, td:first-of-type': { display: 'none !important' },
//                                 'th:last-of-type, td:last-of-type': { display: 'none !important' } 
//                             }}
//                         >
//                             <Box h="100%" display="flex" flexDirection="column" minH={0}>
//                                 <DataTable
//                                     ref={tableRef}
//                                     options={tableOptions}
//                                     access={{ can_edit: false, can_create: false, can_delete: false }}
//                                 />
//                             </Box>
//                         </CardBody>
//                     </Card>
//                 </VStack> 
//             </Box> 
//         </AdminLayout>
//     );
// };

// export default DriversCAHistoryPage;
import React, { useState, useMemo, useRef, useEffect } from 'react';
import { 
    Box, Heading, Text, HStack, VStack, InputGroup, Input, 
    InputRightElement, IconButton, Card, CardHeader, CardBody, 
    Avatar, Icon, Divider, Tag, Select
} from '@chakra-ui/react';
import { Search, Phone, Truck, ChevronLeft, Banknote, ChevronRight, Calendar } from 'lucide-react';
import { useNavigate, useParams } from 'react-router-dom';
import { AdminLayout } from '@/components/layout/AdminLayout';
import { apiClient } from '@/lib/api/client';
import { useToastNotification } from '@/lib/utils/useToastNotification';
import { DataTable, type DataTableRef, type DataTableOptions } from '@/components/tables';
import { useThemeColors } from '@/hooks/useThemeColors';

interface DriverHeaderInfo {
    full_name: string;
    contact_number: string;
    assigned_trucks: string[];
}

const DriversCAHistoryPage: React.FC = () => {
    const { id } = useParams<{ id: string }>();
    const navigate = useNavigate();
    const colors = useThemeColors();
    const tableRef = useRef<DataTableRef>(null);
    const searchRef = useRef<HTMLInputElement>(null);
    const { showError } = useToastNotification();

    const [searchQuery, setSearchQuery] = useState('');
    const [driverInfo, setDriverInfo] = useState<DriverHeaderInfo | null>(null);

    // --- 🌟 FILTER STATE ---
    const [filterType, setFilterType] = useState<'weekly' | 'monthly'>('weekly');
    const [currentDate, setCurrentDate] = useState(new Date());

    // --- 🌟 NAVIGATION LOGIC ---
    const adjustDate = (direction: number) => {
        const newDate = new Date(currentDate);
        if (filterType === 'weekly') {
            newDate.setDate(newDate.getDate() + (direction * 7));
        } else {
            newDate.setMonth(newDate.getMonth() + direction);
        }
        setCurrentDate(newDate);
    };

    const dateRangeDisplay = useMemo(() => {
        const start = new Date(currentDate);
        if (filterType === 'weekly') {
            const day = start.getDay();
            const diff = start.getDate() - day + (day === 0 ? -6 : 1); 
            start.setDate(diff);
            const end = new Date(start);
            end.setDate(start.getDate() + 6);
            return `${start.toLocaleDateString('en-US', { month: 'short', day: 'numeric' })} - ${end.toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric' })}`;
        }
        return start.toLocaleDateString('en-US', { month: 'long', year: 'numeric' });
    }, [currentDate, filterType]);

    // --- 🌟 SYNC TABLE PARAMS ---
    const tableParams = useMemo(() => ({ 
        search: searchQuery,
        filter_type: filterType,
        reference_date: currentDate.toISOString().split('T')[0] 
    }), [searchQuery, filterType, currentDate]);

    useEffect(() => {
        const fetchDriverDetails = async () => {
            try {
                const res = await apiClient.get(`/drivers/${id}`);
                const driverData = res.data.data || res.data; 

                if (driverData) {
                    setDriverInfo({
                        full_name: `${driverData.first_name} ${driverData.last_name}`,
                        contact_number: driverData.contact_number,
                        assigned_trucks: driverData.assigned_truck_plate_numbers || []
                    });
                }
            } catch (err) {
                showError(err);
            }
        };
        if (id) fetchDriverDetails();
    }, [id, showError]);

    const handleSearch = () => {
        const query = searchRef.current?.value || '';
        setSearchQuery(query); 
        tableRef.current?.applyFilter('search', query); 
    };

    // --- 🌟 THE FIX: Explicit Refresh for "No records found" visibility ---
    useEffect(() => {
        if (tableRef.current) {
            (tableRef.current as any).refresh?.();
        }
    }, [filterType, currentDate, searchQuery]);

    // --- 🌟 TABLE OPTIONS ---
    const tableOptions: DataTableOptions = useMemo(
        () => ({
            dataSource: `/drivers/get-cash-advance/${id}`, 
            primaryKey: 'id',
            dataKey: 'data', 
            showSelection: false,
            showCheckboxes: false, // Explicitly false
            showActions: false,    // Explicitly false
            softDelete: false,
            displayInModal: false,
            noRecordText: 'No cash advance records found',
            dataFields: {
                transaction_date: { name: 'DATE ISSUED', withSort: true },
                amount: { name: 'AMOUNT', withSort: true },
                shift: { name: 'SHIFT', withSort: true },
            },
        }),
        [id]
    );

    const customRenderers = useMemo(() => ({
        transaction_date: (val: string) => val ? new Date(val).toLocaleDateString('en-US', {
            month: 'long', day: 'numeric', year: 'numeric'
        }) : 'N/A',
        amount: (val: number) => (
            <Text fontWeight="bold">
                {new Intl.NumberFormat('en-PH', { style: 'currency', currency: 'PHP' }).format(val)}
            </Text>
        ),
        shift: (val: string) => (
            <Tag size="sm" colorScheme={val?.toLowerCase() === 'day' ? 'orange' : 'purple'} variant="subtle">
                {val}
            </Tag>
        )
    }), []);

    if (!driverInfo) return null;

    return (
        <AdminLayout>
            <Box p={4} h="100%" overflow="hidden" display="flex" flexDirection="column">
                <VStack spacing={4} align="stretch" flex="1" overflow="hidden" minH={0}>
                    
                    <Card flexShrink={0} display="flex" flexDirection="column" flex="1" minH={0} overflow="hidden">
                        
                        <CardHeader py={3}>
                            <HStack spacing={2} align="center" cursor="pointer" onClick={() => navigate('/fleet-management/drivers')} mb={1}>
                                <Icon as={ChevronLeft} boxSize={5} />
                                <Heading size="md" fontWeight="bold">Driver's Cash Advance History</Heading>
                            </HStack>
                            <Text fontSize="sm" color={colors.text} ml={7}>
                                View and manage driver's cash advancement records
                            </Text>
                        </CardHeader>

                        <Box px={6} py={4} borderBottom="1px" borderColor="gray.100" bg="gray.50/30">
                            <HStack spacing={10} align="center">
                                <HStack spacing={4} flex="1">
                                    <Avatar size="md" name={driverInfo.full_name} bg="green.500" color="white" icon={<Banknote size={24} />} />
                                    <VStack align="start" spacing={0}>
                                        <Heading size="sm" color="gray.700">{driverInfo.full_name}</Heading>
                                        <HStack color="gray.500" fontSize="xs">
                                            <Icon as={Phone} size={12} />
                                            <Text>{driverInfo.contact_number || 'N/A'}</Text>
                                        </HStack>
                                    </VStack>
                                </HStack>

                                <Divider orientation="vertical" height="30px" />

                                <Box minW="200px">
                                    <Text fontSize="xs" fontWeight="bold" color="gray.400" mb={1}>ASSIGNED TRUCKS:</Text>
                                    <HStack spacing={2}>
                                        <Icon as={Truck} size={14} color="gray.400" />
                                        {driverInfo.assigned_trucks.length ? (
                                            driverInfo.assigned_trucks.map((plate: string) => (
                                                <Tag key={plate} colorScheme="blue" variant="subtle" size="sm">{plate}</Tag>
                                            ))
                                        ) : (
                                            <Text fontSize="xs" color="gray.500">None Assigned</Text>
                                        )}
                                    </HStack>
                                </Box>
                            </HStack>
                        </Box>
                        
                        {/* 🌟 UNIFIED FILTER BAR */}
                        <CardHeader py={4} px={6}>
                            <HStack justify="space-between" align="center" w="100%">
                                <HStack spacing={4}>
                                    <Select 
                                        size="sm" w="120px" borderRadius="md" 
                                        value={filterType} 
                                        onChange={(e) => setFilterType(e.target.value as any)}
                                    >
                                        <option value="weekly">Weekly</option>
                                        <option value="monthly">Monthly</option>
                                    </Select>
                                    
                                    <HStack spacing={1}>
                                        <IconButton icon={<ChevronLeft size={18} />} aria-label="Prev" size="sm" variant="ghost" onClick={() => adjustDate(-1)} />
                                        <HStack 
                                            border="1px solid" borderColor="gray.200" px={3} py={1.5} borderRadius="md" 
                                            bg="white" cursor="pointer" position="relative"
                                            onClick={() => (document.getElementById('ca-date-picker') as HTMLInputElement)?.showPicker()}
                                        >
                                            <Icon as={Calendar} size={14} color="gray.500" />
                                            <Text fontWeight="medium" fontSize="sm">{dateRangeDisplay}</Text>
                                            <input 
                                                id="ca-date-picker" type="date" 
                                                style={{ width: 0, height: 0, opacity: 0, position: 'absolute' }}
                                                onChange={(e) => e.target.value && setCurrentDate(new Date(e.target.value))}
                                            />
                                        </HStack>
                                        <IconButton icon={<ChevronRight size={18} />} aria-label="Next" size="sm" variant="ghost" onClick={() => adjustDate(1)} />
                                    </HStack>
                                </HStack>

                                <Box flex="0 1 auto" minW="250px" maxW="400px">
                                    <InputGroup size="sm">
                                        <Input
                                            ref={searchRef}
                                            placeholder="Search CA records..."
                                            onKeyDown={(e) => e.key === 'Enter' && handleSearch()}
                                            defaultValue={searchQuery}
                                        />
                                        <InputRightElement width="2.5rem">
                                            <IconButton aria-label="Search" icon={<Search size={16} />} size="sm" variant="ghost" onClick={handleSearch} />
                                        </InputRightElement>
                                    </InputGroup>
                                </Box>
                            </HStack>
                        </CardHeader>
                        
                        <CardBody p={0} pt={1} pb={4} mx={6} flex="1" overflow="hidden" display="flex" flexDirection="column">
                            <Box h="100%" display="flex" flexDirection="column" minH={0}>
                                <DataTable
                                    ref={tableRef}
                                    options={tableOptions}
                                    params={tableParams}
                                    customRenderers={customRenderers}
                                    access={{ can_edit: false, can_create: false, can_delete: false }}
                                />
                            </Box>
                        </CardBody>
                    </Card>
                </VStack> 
            </Box> 
        </AdminLayout>
    );
};

export default DriversCAHistoryPage;